import { render } from "./Step3OptionalData.vue?vue&type=template&id=168abf8f&scoped=true&ts=true"
import script from "./Step3OptionalData.vue?vue&type=script&lang=ts"
export * from "./Step3OptionalData.vue?vue&type=script&lang=ts"

import "./Step3OptionalData.vue?vue&type=style&index=0&id=168abf8f&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_au_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168abf8f"]])

export default __exports__